var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAvailibilityAvailable = function SvgIconAvailibilityAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#3CF11A",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.017 6.286a.774.774 0 0 1-.054 1.036l-4.381 4.381a.772.772 0 0 1-1.095 0l-2.26-2.26A.774.774 0 1 1 6.32 8.348l1.713 1.713 3.835-3.834a.773.773 0 0 1 1.036-.053l.058.053.054.059z",
    fill: "#FFF"
  }))));
};
export default SvgIconAvailibilityAvailable;